<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-button
      v-if="$acl.check('trainee')"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      :to="{ name: 'RequestCourseClass' }"
      >{{$t('AddNew')}}</vs-button
    >
    <vs-button
      v-if="$acl.check('customer')"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      :to="{ name: 'CustomerCourseRequest' }"
      >{{$t('AddNew')}}</vs-button
    >
    <vx-card
      v-for="tr in courseRequests"
      :key="tr.ID"
      card-background="#ebf7ff"
      class="mt-5"
      content-color="#fff"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/5 justify-center">
          <img :src="baseUrl + tr.Status.ImagePath" alt="" class="w-full" />
        </div>
        <div class="vx-col lg:w-1/5">
          <img alt="" class="ml-5" src="@/assets/images/education.svg" />
          <div class="lg:w-2/3 ml-2">
            <h4 style="" v-if="tr.Course">{{ tr.Course.Name }}</h4>
            <h4 style="" v-if="!tr.Course">{{ tr.CourseName }}</h4>
            <div class="mt-5" style="color: #ada8a8">{{$t('StartDate')}}</div>
            <p style="color: #5e5e5e">
              {{ tr.RequestStartDate.split("T")[0] }}
            </p>
            <p class="mt-5" style="color: #ada8a8">{{$t('Status')}}</p>
            <p style="color: #5e5e5e">{{ tr.Status.Name }}</p>
          </div>
        </div>
        <div class="vx-col lg:w-3/5" style="color:black" >
              <div class="mb-2" v-if="tr.Status.ID==10||tr.Status.ID==15||tr.Status.ID==16">
                  {{tr.Status.Description}}
              </div>

              <div v-if="tr.Status.ID==11">
                   <p v-if="tr.ProposalRequest&&tr.ProposalRequest.ProposalStatusID==1">{{tr.Status.Description}}</p>
                   <vs-table v-if="tr.ProposalRequest&&tr.ProposalRequest.ProposalStatusID==1">
                        <template slot="thead">
                            <vs-th sort-key="Name">{{$t('FinancialProposal')}}</vs-th>
                            <vs-th sort-key="Provider">
                              <a   :href="baseUrl+tr.ProposalRequest.DocUrl"  download target="_blank"><feather-icon icon="DownloadIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2"  /></a>
                            </vs-th>
                            <vs-th sort-key="Code">
                                <vs-button color="success" class="mr-2" @click="ChangeProposalStatus(tr,3)">
                                    {{$t('Accept')}}
                                </vs-button>

                                <vs-button color="danger" @click="ChangeProposalStatus(tr,2)">
                                    {{$t('Decline')}}
                                </vs-button>
                            </vs-th>
                        </template>
                    </vs-table>
                    <div v-if="tr.ProposalRequest&&tr.ProposalRequest.ProposalStatusID==2">
                      {{$t('SendYouOtherProposal')}}
                    </div>
                     <div v-if="tr.ProposalRequest&&tr.ProposalRequest.ProposalStatusID==3">
                         {{$t('ThanksForApprove')}}
                    </div>
              </div>

              <div v-if="tr.Status.ID==14">
                    <div v-if="tr.PaymentTypeID== 2 && tr.InvoiceDetails.length>0 && !tr.InvoiceDetails[0].ConfirmPayAttachement">
                          <h6 style="color:orange">{{$t('PaymentSwiftCheck')}}</h6>
                          <vs-upload  automatic :limit="1" :action="uploadUrl+'?id='+tr.ID" :headers="UploadRequestHeader"  @on-success="successUploadPayProof" />
                    </div>
                    <div v-if="tr.PaymentTypeID==2 && tr.InvoiceDetails.length>0 && tr.InvoiceDetails[0].ConfirmPayAttachement">
                         {{$t('ThanksForPayment')}}
                    </div>
                    <div v-else>
                        {{tr.Status.Description}}
                    </div>
              </div>

              <div v-if="tr.Status.ID==17">
                 <vs-checkbox v-if="tr.IsVisaRequired&&!tr.TravelDataFilled&&tr.IsVisaOnArrival" v-model="tr.VisaOnArrival">{{$t('VisaOnArrival')}}</vs-checkbox>
                  <vs-table v-if="!tr.AccumodationFilled||(tr.IsVisaRequired&&!tr.TravelDataFilled)||(!tr.CourseRequestTrainees[0].VisaProof&&!tr.VisaOnArrival)||!tr.CourseRequestTrainees[0].FlightTicket">

                        <template slot="thead">
                          <vs-th sort-key="Name">{{$t('TraineeName')}}</vs-th>
                          <vs-th sort-key="Code"> <span v-if="tr.IsVisaRequired&&!tr.TravelDataFilled" >{{$t('NameAsPassport')}},
                            {{$t('PassportNumber')}},</span>
                            <span v-if="!tr.AccumodationFilled">{{$t('Accommodation')}}</span></vs-th>
                          <vs-th sort-key="Category" v-if="(tr.IsVisaRequired&&!tr.TravelDataFilled)
                          ||(!tr.CourseRequestTrainees[0].VisaProof&&tr.IsVisaRequired&&tr.TravelDataFilled)">
                          <p v-if="(tr.IsVisaRequired&&!tr.TravelDataFilled)">{{$t('PassportAttachment')}}</p>
                           <p v-if="(!tr.CourseRequestTrainees[0].VisaProof&&tr.IsVisaRequired&&tr.TravelDataFilled&& !tr.VisaOnArrival)">{{$t('VisaProof')}}</p>
                          </vs-th>
                          <vs-th v-if="(tr.IsVisaRequired&&tr.TravelDataFilled&&!tr.CourseRequestTrainees[0].FlightTicket)">
                            <p > {{$t('FlightTicket')}}</p>
                          </vs-th>
                        </template>
                        <template>
                           <tbody>
                             <vs-tr v-for="trainee in tr.CourseRequestTrainees" :key="trainee.ID">
                               <vs-td>
                                  {{trainee.TraineeName}}
                               </vs-td>
                               <vs-td>
                                   <vs-input v-if="tr.IsVisaRequired&&!tr.TravelDataFilled"   v-model="trainee.PassportNumber" :label="$t('PassportNumber')" class="w-full"></vs-input>
                                    <vs-input  v-if="tr.IsVisaRequired&&!tr.TravelDataFilled" v-model="trainee.NameAsPassport" :label="$t('NameAsPassport')" class="w-full"></vs-input>
                                      <div v-if="!tr.AccumodationFilled" class="mt-1">
                                        <vs-checkbox v-model="trainee.WithAccommodation">{{$t('WithAccommodation')}}</vs-checkbox>
                                        <div v-if="trainee.WithAccommodation" class="mt-2" >
                                            <p>{{$t('RoomType')}}</p>
                                            <v-select
                                                label="Name"
                                                class=" w-full"
                                                  autocomplete
                                                v-model="trainee.RoomType"
                                                :options="RoomTypes"
                                                :reduce="Name => Name.Name"
                                            />
                                        </div>
                                    </div>
                               </vs-td>
                               <vs-td v-if="(tr.IsVisaRequired&&!tr.TravelDataFilled)||!tr.CourseRequestTrainees[0].VisaProof||!tr.CourseRequestTrainees[0].FlightTicket">
                                   <vs-upload  v-if="(tr.IsVisaRequired&&!tr.TravelDataFilled)" automatic :limit="1" :action="uploadUrl+'?id='+trainee.ID" :headers="UploadRequestHeader"  @on-success="successUploadPassport" />
                                   <vs-upload v-if="!tr.CourseRequestTrainees[0].VisaProof&&tr.IsVisaRequired&&tr.TravelDataFilled&& !tr.VisaOnArrival"  automatic :limit="1" :action="uploadUrl+'?id='+trainee.ID" :headers="UploadRequestHeader"  @on-success="successUploadVisaProof" />
                               </vs-td>
                               <vs-td>
                                   <vs-upload v-if="!tr.CourseRequestTrainees[0].FlightTicket&&tr.IsVisaRequired&&tr.TravelDataFilled"  automatic :limit="1" :action="uploadUrl+'?id='+trainee.ID" :headers="UploadRequestHeader"  @on-success="successUploadFlightTicket" />
                               </vs-td>
                             </vs-tr>
                           </tbody>
                        </template>
                  </vs-table>
                  <div class="mt-2 vx-col lg:w-1/5 margin-auto" v-if="!tr.AccumodationFilled||(tr.IsVisaRequired&&!tr.TravelDataFilled)||(!tr.CourseRequestTrainees[0].VisaProof && !tr.VisaOnArrival) || !tr.CourseRequestTrainees[0].FlightTicket ">
                    <vs-button  color="#3D7299"   :disabled="validateForm(tr)" type="filled" @click="SaveRequestTrainees(tr.CourseRequestTrainees,tr.VisaOnArrival)">{{$t('Submit')}}</vs-button>
                  </div>
                  <div v-else>
                     {{$t('PleaseProvSubmit')}}
                  </div>
              </div>

        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import moduleCourseRequest from "@/store/courseRequest/moduleCourseRequest.js";
import { domain, mainSetting } from "@/gloabelConstant.js";
import vSelect from 'vue-select'
export default {
  components:{
       vSelect
  },
  data() {

    return {
      search: {},
      baseUrl: domain,
      UploadRequestHeader:mainSetting.UploadRequestHeader,
       uploadUrl: domain + "API/Course/UploadFile",
       RoomTypes:[
        {ID:1,Name:"Single  50 USD",Price:""},
        {ID:2,Name:"Double 40 USD",Price:""},
        {ID:2,Name:"Triple 30 USD",Price:""}
      ]
    };
  },
  methods: {
    validateForm(tr)
    {
      var valid=true;

       tr.CourseRequestTrainees.forEach(element => {
            if(!tr.TravelDataFilled)
            {
              if(!element.PassportNumber)
                  valid=false;
              if(!element.NameAsPassport)
                  valid=false;
              if(! element.uploadPassPort)
                valid=false;
            }
       });
       return !valid;
    },
    SaveRequestTrainees(trainees,VisaOnArrival)
    {
      debugger
      trainees[0].VisaOnArrival = VisaOnArrival;
       this.$store.dispatch("courseRequestList/SaveRequestTrainees", trainees).then(res=>{
          this.$store
              .dispatch("courseRequestList/GetCourseRequestByUser")

              var els = document.getElementsByClassName("btn-x-file");
        els.forEach(element => {
             element.click();
        });

            this.$vs.notify({
              color: "success",
              title: "Upload Success",
               text: this.$t("TraineeDataSavedSuccessfully")

            });
         });
    },
    successUploadPassport(event) {

      var obj = {};
      obj.ID = event.target.responseText.split('_')[1];
      obj.PassportPath = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRequestList/SaveTraineePassport", obj).then(res=>{
       debugger
       var request =  this.courseRequests.filter(x=> x.CourseRequestTrainees.findIndex(e=>e.ID==obj.ID)!=-1 );
        var trinee =  request[0].CourseRequestTrainees.filter(e=>e.ID==obj.ID);

        this.$set(trinee[0], 'uploadPassPort', true)
        this.$vs.notify({
          color: "success",
          title: "Upload Success",
          text: this.$t("SuccessuploadyourAttachment")
        });

      });
    },

     successUploadVisaProof(event) {
      debugger
      var obj = {};
      obj.ID = event.target.responseText.split('_')[1];
      obj.VisaProof = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRequestList/SaveTraineeVisaProof", obj).then(res=>{

        this.$vs.notify({
          color: "success",
          title: "Upload Success",
           text: this.$t("SuccessuploadyourAttachment")
        });

      });
    },
    successUploadFlightTicket(event)
    {
      debugger
      var obj = {};
      obj.ID = event.target.responseText.split('_')[1];
      obj.FlightTicket = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRequestList/SaveTraineeFlightTicket", obj).then(res => {

        this.$vs.notify({
          color: "success",
          title: "Upload Success",
       text: this.$t("SuccessuploadyourAttachment")
        });

      });
    },
     successUploadPayProof(event) {
      debugger
      var obj = {};
      obj.CourseRequestID = event.target.responseText.split('_')[1];
      obj.ConfirmPayAttachement = event.target.responseText.split('_')[0];
      this.$store.dispatch("courseRequestList/SavePaymentProof", obj).then(res => {
          this.$store
              .dispatch("courseRequestList/GetCourseRequestByUser")
      });
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
         text: this.$t("SuccessuploadyourAttachment")
      });
    },

    ChangeProposalStatus(courseRequest,statusId)
    {
      var data={};
      data.StatusID=statusId;
      data.ProposalRequestID = courseRequest.ProposalRequestID;
      data.CourseRequestID = courseRequest.ID;
        this.$store
          .dispatch("courseRequestList/ChangeProposalStatus",data)
          .then(() => {
              this.$store
                .dispatch("courseRequestList/GetCourseRequestByUser");
                vm.$vs.notify({
                      color: "success",
                      title: "Save success",
                      text: "Your Operation done successfully",
                    });
          })
          .catch(() => {
            this.$vs.loading.close();
          });
    },
    searchCourseRequest()
    {
      this.$vs.loading();
       this.$store
          .dispatch("courseRequestList/GetCourseRequestByUser")
          .then(() => {
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
          });
     }
  },
  computed: {
    courseRequests() {
      return this.$store.state.courseRequestList.courseRequests;
    },
  },
  created() {
    if (!moduleCourseRequest.isRegistered) {
      this.$store.registerModule("courseRequestList", moduleCourseRequest);
      moduleCourseRequest.isRegistered = true;
    }

    this.search.StartDate = new Date().getFullYear() + "/01/01";
    this.search.EndDate = new Date().getFullYear() + "/12/31";
    this.searchCourseRequest();
  },
};
</script>
<style >
.vs-table--not-data
{
  display: none;
}
.con-img-upload
{
  background-color: transparent;
}
</style>


<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
